
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import Pagination from "@components/base/pagination/CenterPagination.vue";
import { getAreaCN } from "@/common/utils";
import { pageViewUnit } from "@/config";
import { collectionList, addCollection, deleteCollection } from "@/api/policy";
@Component({
  name: "SubscribeList",
  components: { Pagination },
})
export default class SubscribeList extends Vue {
  @Getter("id") private id!: string;
  @Action("account/addSubscribe") private addSubscribe: any;
  @Action("account/getSubscribeList") private getSubscribeList: any;
  @Action("account/getSubscribeSetList") private getSubscribeSetList: any;
  setting: any = [];
  active: any = 0;
  base_apply_direction: any = 65;
  dialogVisible: Boolean = false;
  tableData: any = [];
  areaList: any = [];
  departList: any = [];
  keyList: any = [];
  areaOption = this.$root.$data.areaOption;
  pages = 0;
  total = 0;
  size = 10;
  current = 1;
  activeName = "政策库";
  created() {
    this.getData();
  }
  directionChange(index: any) {
    this.active = index;
    this.getTableData();
  }
  handleClick() {
    this.getTableData();
  }
  // 取消收藏
  handleCancel(item: any) {
    let type = "policy";
    if (
      this.activeName == "政策库" ||
      this.activeName == "解读" ||
      this.activeName == "公示公告"
    ) {
      type = "policy";
    } else {
      type = this.activeName;
    }
    let options = {
      type: type,
      id: item.id,
    };
    if (this.activeName == "declare") {
      options.declareDirectionId = item.declareDirectionId;
    }
    deleteCollection(options).then((res) => {
      this.$message("取消收藏成功");
      this.getData();
    });
  }
  check(item: any) {
    console.log(item, "item");
    switch (this.activeName) {
      case "政策库":
        // this.$router.push({
        //   path: "/pcm/policyDetail",
        //   query: {
        //     publicyId: item.id,
        //   },
        // });
		const url = `/#/pcm/policyDetail?publicyId=`+item.id;
		window.open(url, "_blank");
        break;
      case "解读":
        this.$router.push({
          path: "/detail/text",
          query: {
            textId: item.id,
          },
        });
        break;
      case "公示公告":
        this.$router.push({
          path: "/detail/publicy",
          query: {
            publicyId: item.id,
          },
        });
        break;
      case "declare":
        this.$router.push({
          path: "/detail/apply",
          query: {
            projectId: item.id,
            directionId: item.declareDirectionId,
          },
        });
        break;
      case "enjoy":
        this.$router.push({
          path: "/pcm/erDetails",
          query: {
            id: item.id,
          },
        });
        break;
      default:
        //这里是没有找到对应的值处理
        break;
    }
  }
  async getBtnData() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    setTimeout(() => {
      loading && loading.close();
    }, 30000);
    await this.getSubscribeSetList().then(({ code, result, msg }: any) => {
      if (code === 200 && result.length > 0) {
        // 过滤无数据订阅设置
        this.setting = result.filter(
          ({ title, departmentId, addressCode }: any) => {
            return title || departmentId || addressCode;
          }
        );
        loading && loading.close();
        return true;
      }
      loading && loading.close();
      return false;
    });
  }
  async getData() {
    //await this.getBtnData();
    await this.getTableData();
  }
  async getTableData() {
    const options = {
      pageNumber: this.current,
      pageSize: this.size,
      type2: "",
    };
    let type = "polciy";
    if (
      this.activeName == "政策库" ||
      this.activeName == "解读" ||
      this.activeName == "公示公告"
    ) {
      options.type2 = this.activeName;
    } else {
      type = this.activeName;
    }
    collectionList(options, type).then((res: any) => {
      const { code, result, msg } = res.data;
      if (code === 200 && result) {
        let { records, total, pages } = result;
        this.total = total;
        this.pages = pages;
        this.tableData = records;
      }
    });
  }
  handleSizeChange(val: any) {}
  handleCurrentChange(val: any) {
    this.current = val;
    this.getData();
  }
}
